export enum ShippingLocation {
  Greece = 1,
  Europe = 2,
  Worldwide = 3,
}